import $ from 'jquery';

export function setupMultiSelect(selector, postKey){

  if (!selector){
    return;
  }

  var dataKey = selector.attr("data-key");
  var dataLabel = selector.attr("data-label");

  selector.find(".multi-select-item").click(function(){

    if ($(this).hasClass("active")){
      $(this).removeClass("active")
    } else {
      $(this).addClass("active")
    }

  });

  selector.find("input").keyup(function(){

    const searchValue = $(this).val().toUpperCase();

    if (searchValue === ""){
      selector.find(".multi-select-item").removeClass("hidden");
      return;
    }

    selector.find(".multi-select-item").each(function(){

      const ref = $(this).text().toUpperCase();

      if (ref.indexOf(searchValue) == -1){
        $(this).addClass("hidden");
      } else {
        $(this).removeClass("hidden");
      }

    });

  });

  selector.find("button.clear-all").click(function(){
    clearAll();
  })

  selector.find("button.select-all").click(function(){
    selectAll();
  })

  function getPostData(){

    var data = "";
    if (selector.attr("data-select-all") === true || selector.attr("data-select-all") === "true"){
      data += "&" + postKey + "SelectAll=true";
    }
    
    selector.find(".multi-select-item.active").each(function(){
      data += "&" + postKey + "[]" + "=" + $(this).attr("data-id");
    });

    return data;
  }

  function clearAll(){
    selector.find(".multi-select-item").removeClass("active");
    selector.find("input").val("").trigger("keyup");
    selector.attr("data-select-all", false);
  }

  function selectAll(){
    selector.find(".multi-select-item").addClass("active");
    selector.attr("data-select-all", true);
  }

  return {
    getPostData: getPostData,
    clearAll: clearAll
  }

}
